import { render, staticRenderFns } from "./AddSupplierA.vue?vue&type=template&id=459148d6&scoped=true&"
import script from "./AddSupplierA.vue?vue&type=script&lang=js&"
export * from "./AddSupplierA.vue?vue&type=script&lang=js&"
import style0 from "./AddSupplierA.vue?vue&type=style&index=0&id=459148d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459148d6",
  null
  
)

export default component.exports